document.addEventListener("DOMContentLoaded", function () {
 function swiper_init()
   {
      const swiperContainers = document.querySelectorAll(".collectionSwiper");
  swiperContainers.forEach(function (swiperContainer) {
    const params = {
      slidesPerView: 1.2,
      spaceBetween: 10,
      centeredSlides: false,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 20,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 3.2,
          spaceBetween: 30,
          centeredSlides: false,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 40,
          centeredSlides: false,
        },
      },
    };

    Object.assign(swiperContainer, params);
    swiperContainer.initialize();
  });
   }

  swiper_init();
  
  function swiper_define() {
     console.log("jjjjjjjjjjjjjjjjjjjjjjjj");
    //swiper 1
    var productSwiper = new Swiper(".productSwiper", {
      loop: false,
      spaceBetween: 10,
      slidesPerView: 5,

      watchSlidesProgress: true,
    });
    var productUpSwiper = new Swiper(".productUpSwiper", {
      zoom: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      thumbs: {
        swiper: productSwiper,
      },
    });
  }
  swiper_define();
  
});

if ($(window).width() < 767){
$(".wrapper-iframe iframe").css("opacity", "0");
}
$(window).load(function() {
 // executes when complete page is fully loaded, including all frames, objects and images

  var iframeHeight = $(".wrapper-iframe iframe").height();
  //alert(iframeHeight);
  var newHeight = iframeHeight + 70;
   setTimeout(function () {
     if ($(window).width() < 767){
       
       $(".wrapper-iframe iframe").css("height", newHeight);
       $(".wrapper-iframe iframe").css("opacity", "1");
     }
      }, 100);

 // $(".wrapper-iframe iframe") {
   
 // }
});



document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('.header__menu-item');
  const menuLinks = document.querySelectorAll('.main-menu-link');

  function closeAllMenus() {
    menuItems.forEach(item => item.classList.remove('is-open'));
    menuLinks.forEach(link => link.classList.remove('is-open'));
  }

  // Menu link click
  menuLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const parentItem = link.closest('.header__menu-item');
      const hasMega = parentItem.querySelector('.mega-container-bg');

      if (!hasMega) return;

      e.preventDefault();

      const isOpen = parentItem.classList.contains('is-open');

      closeAllMenus();

      if (!isOpen) {
        parentItem.classList.add('is-open');
        link.classList.add('is-open');
      }
    });
  });

  // ✅ CLOSE WHEN CLICKING THE :after OVERLAY AREA
  document.addEventListener('click', (e) => {
    const megaBg = e.target.closest('.mega-container-bg');

    // Click happened on mega background
    if (megaBg) {
      // BUT not inside actual mega menu content
      if (!e.target.closest('.mega-container')) {
        closeAllMenus();
      }
      return;
    }

    // Click completely outside header
    if (!e.target.closest('.header__menu-item')) {
      closeAllMenus();
    }
  });

  // ESC close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllMenus();
    }
  });
});
